// extracted by mini-css-extract-plugin
export default {"container":"container§LWHEyzlo40tOLMerspLK","center":"center§TIWopaFp7HZVHzUGHsmb"};